/**
 * Session storage key for MenuOverview used to save if the collapsible
 * list component has been opened or closed.
 */
export const OPEN_MENU_LIST = 'openMenuList'
